import { useEffect, useRef } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { IGNORE_WISE_POPS_PATHS } from 'consts/paths';
import * as userSelectors from 'store/user/selectors';

const useWisePops = () => {
  const { pathname } = useLocation();
  const isScriptLoaded = useRef(false);
  const isUserLoaded = useSelector(userSelectors.getLoaded);
  const isUserAuthorized = Boolean(useSelector(userSelectors.getUserId));

  useEffect(() => {
    const isIgnorePath = IGNORE_WISE_POPS_PATHS.some(path => matchPath(pathname, { path, exact: true, strict: false }));

    if (isUserLoaded && !isUserAuthorized && !isScriptLoaded.current && !isIgnorePath) {
      isScriptLoaded.current = true;

      /* eslint-disable */
      (function (W, i, s, e, P, o, p) {
        W['WisePopsObject'] = P;
        (W[P] =
          W[P] ||
          function () {
            (W[P].q = W[P].q || []).push(arguments);
          }),
          (W[P].l = 1 * new Date());
        (o = i.createElement(s)), (p = i.getElementsByTagName(s)[0]);
        o.defer = 1;
        o.src = e;
        p.parentNode.insertBefore(o, p);
      })(window, document, 'script', '//wisepops.net/loader.js?v=2&h=rGnYY6c3GD', 'wisepops');
      /* eslint-enable */
    }
  }, [isUserLoaded, isUserAuthorized, pathname]);
};

export default useWisePops;
